export enum LinkVariant {
	Underline = "Underline",
	NoStyle = "NoStyle",
	Disabled = "Disabled",
	EventsNone = "EventsNone",
	MenuItemLink = "MenuItemLink",
}

export function getLinkClass(variant: LinkVariant = LinkVariant.Underline): string {
	switch (variant) {
		case LinkVariant.Underline:
			return "link";
		case LinkVariant.NoStyle:
			return "";
		case LinkVariant.MenuItemLink:
			return "text-menu-item text-black uppercase inline-block font-medium tracking-[5%] hover:text-zms-blue md:hover:text-black duration-300 transition-colors";
		case LinkVariant.Disabled:
			return "cursor-not-allowed";
		case LinkVariant.EventsNone:
			return "pointer-events-none";
	}
}
